// src/context/BrandingContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getBranding } from '../utils/api';

const DEFAULTS = {
  brand_name: 'EMS',
  logo_url: '',
  favicon_url: '',
  primary_color: '#2563eb',
  login_tagline: '',
  powered_by_enabled: '0',
};

const BrandingContext = createContext({ branding: DEFAULTS, loading: true });

// Builds the same inline-SVG initials badge used as a favicon fallback, so a
// client with no favicon_url set still gets something reasonable instead of
// a browser default icon.
function initialsFaviconDataUri(brandName, color) {
  const initials = (brandName || 'EMS').trim().split(/\s+/).map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'EM';
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='50' fill='${color}'/><text y='.35em' x='50%' dy='.1em' font-size='55' font-family='sans-serif' text-anchor='middle' fill='white'>${initials}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBranding()
      .then(r => setBranding({ ...DEFAULTS, ...r.data }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    document.title = `${branding.brand_name} EMS`;

    document.documentElement.style.setProperty('--primary', branding.primary_color || DEFAULTS.primary_color);

    let iconHref = branding.favicon_url;
    if (!iconHref) iconHref = initialsFaviconDataUri(branding.brand_name, branding.primary_color || DEFAULTS.primary_color);
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = iconHref;
  }, [branding]);

  return (
    <BrandingContext.Provider value={{ branding, loading }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
